const layers = {
  'zero': 0,
  'default': 1,
  'promo3dplan': 1,
  'firstscreenMobile': 0,
  'firstscreenTabletL': 2,
  'youdesignMObile': 1,
  'footer': 2,
  'dream-interior': 3,
  'mobile-menu': 4,
  'main-header': 5,
  'price-header': 5,
  'modal': 5,
  'cookies': 5,
};

export const zIndex = (key) => layers[key];
